import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const setSoldAuctionStatusV2 = async (auctionId, statusField, observations, dateTime, pdfs = [], context = {}) => {
  if (!auctionId || !statusField) {
    console.error('auctionId y statusField son requeridos');
    return { success: 'no', message: 'auctionId y statusField son requeridos' };
  }

  try {
    const setSoldAuctionStatusFn = httpsCallable(functions, 'setSoldAuctionStatusV2');
    const result = await setSoldAuctionStatusFn({
      auctionId,
      statusField,
      observations: observations || '',
      dateTime: dateTime || new Date().getTime(),
      pdfs: pdfs || [],
      operatingUnitId: context.activeUnitId,
      dealershipId: context.dealershipId || context.dealership,
      requestedApp: 'dealership_web',
    });
    return result.data;
  } catch (error) {
    console.error('Error actualizando estado de subasta:', error);
    notifyPermissionDenied(error);
    return { success: 'no', message: error.message };
  }
};
